import { HttpClient, HttpContext } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { REQUEST_META_DATA } from '@seech-sub/core-ng';
import { Observable } from 'rxjs';
import { OperationsApiRoutes } from '../constants/operations.constants';
import { AdminAuditEventResponse, GrowthMetricsQuery, GrowthMetricsResponse, OperationsDashboardSummary } from '../models';

@Injectable({
  providedIn: 'root',
})
export class DashboardClientService {
  private readonly quietContext = new HttpContext().set(REQUEST_META_DATA.HIDE_PROGRESS, true);
  private readonly http = inject(HttpClient);

  getDashboardSummary(): Observable<OperationsDashboardSummary> {
    return this.http.get<OperationsDashboardSummary>(OperationsApiRoutes.dashboardSummary, {
      context: this.quietContext,
    });
  }

  getGrowthMetrics(query: GrowthMetricsQuery): Observable<GrowthMetricsResponse> {
    return this.http.post<GrowthMetricsResponse>(OperationsApiRoutes.dashboardGrowth, query, {
      context: this.quietContext,
    });
  }

  getRecentAuditEvents(limit = 20): Observable<AdminAuditEventResponse[]> {
    return this.http.get<AdminAuditEventResponse[]>(OperationsApiRoutes.recentAudit, {
      params: { limit },
      context: this.quietContext,
    });
  }
}
